import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import getNestedValue from '../../Helpers/nestedValue';

const TextDate = ({
    entity,
    name,
    resource,
    isParagraph = false,
    isNested = false,
    includeLabel = false,
    ...props
}) => {
    const { t } = useTranslation();

    if (!entity) return null;

    const Paragraph = isParagraph ? 'p' : 'span';
    const dateValue = isNested ? getNestedValue(entity, name) : entity?.[name];
    const content = dateValue ? new Date(dateValue).toLocaleString() : null;

    if (includeLabel) {
        return (
            <div className="flex flex-col">
                <span>{t(`${resource}.${name}`)}</span>
                <Paragraph {...props}>{content ?? '-'}</Paragraph>
            </div>
        );
    }

    return <Paragraph {...props}>{content ?? '-'}</Paragraph>;
};

export default TextDate;

TextDate.propTypes = {
    /**
     * Type of entity
     */
    entity: PropTypes.object.isRequired,
    /**
     * Type of name
     */
    name: PropTypes.string.isRequired,
    /**
     * Type of resource
     */
    resource: PropTypes.string.isRequired,
    /**
     * Type of name
     */
    isParagraph: PropTypes.bool,
    /**
     * Type of name
     */
    isNested: PropTypes.bool,
    /**
     * Type of includeLabel
     */
    includeLabel: PropTypes.bool,
};

TextDate.defaultProps = {
    isParagraph: false,
    isNested: false,
    includeLabel: false,
};
